import React, { Component, Fragment } from "react";
import { withLayout } from "hocs";
import { Link } from "react-router-dom";

import Logo from 'assets/images/logo.svg';

class NotFound extends Component {
  render() {
    return (
      <Fragment>
        <div class="account-pages">
          <div class="clearfix" />
          <div class="wrapper-page">
            <div class="ex-page-content text-center">
              <img src={Logo} alt="" style={{ marginBottom: 30 }} />
              <h3 class="text-uppercase font-600">Página em Manutenção</h3>
              <p class="text-muted">
                Desculpe, estamos passando por uma manutenção. <br />
                Horário: 9h às 12h - 31/03/2020 <br />É rapidinho, estamos
                rodando alguns procedimentos para melhoria de performance da
                aplicação
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withLayout("Blank")(NotFound);



// WEBPACK FOOTER //
// ./src/pages/Errors/Maintanence/index.js